import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-organization-builder-form',
  templateUrl: './organization-builder-form.component.html',
  styleUrls: ['./organization-builder-form.component.scss'],
})
export class OrganizationBuilderFormComponent {
  organization_builder_form_group: FormGroup = this.form_service.organization_builder_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(private form_service: FormService, private navigation_service: NavigationService) {}

  onConfirmClick(): void {
    this.navigation_service.toUnitDetails('un_123test');
  }
}
